import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { NgOtpInputComponent } from 'ng-otp-input';
import { focusFirstOtpInput } from '../../sign-in/focus-otp';
import { toDataURL } from 'qrcode';

@Component({
  selector: 'app-totp-setup',
  standalone: false,
  templateUrl: './totp-setup.component.html',
  styleUrl: './totp-setup.component.css'
})
export class TotpSetupComponent implements OnInit, OnDestroy {

  qrcodeTitle: string = "Scan QR Code";
  tokenTitle: string = "Enter token";
  errorMessage: string = "";
  qrcodeDataUrl = '';

  token = '';
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput!: NgOtpInputComponent; //ng-otp-input
  config = {
    allowNumbersOnly: true,
    length: 6,
    inputStyles: {
      width: '40px',
      height: '50px',
    }
  };

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TotpSetupComponent>,
    host: ElementRef<HTMLElement>
  ) {
    focusFirstOtpInput(dialogRef, host);
  }

  ngOnInit(): void {
    console.error('TotpSetupComponent -> ngOnInit')
    toDataURL(this.data.otpauthUrl)
      .then(url => this.qrcodeDataUrl = url)
      .catch(() => this.errorMessage = 'Não foi possível gerar o QR Code.');
  }

  ngOnDestroy(): void {
    console.warn('TotpSetupComponent -> ngOnDestroy');
  }

  onOtpChange(otp: any) {
    this.token = otp ?? '';
  }

  paste(){
    console.warn('TotpSetupComponent -> paste') 

    navigator.clipboard.readText()
    .then(
      (text: string) => {
        this.ngOtpInput.setValue(text)
          this.token = text.replace(/\D/g, '').slice(0, 6);
        this.confirm()
      })
    .catch(error => {
        console.error('Cannot read clipboard text: ', error)
    })
  }

  confirm() {
    if (!/^\d{6}$/.test(this.token)) {
      this.errorMessage = 'Informe o código de seis dígitos.';
      return;
    }

    this.dialogRef.close({ code: this.token });
  }
}
